<script>


  // should be explicitly enumerated for tailwind compiler
  const PositionMapping = {
    'start' : 'dropdown-start',
    'end' : 'dropdown-end',
  }

</script>
<script setup>
import Button from './Button.vue';
import {onMounted, onUnmounted, ref, watch} from 'vue';
import {autoUpdate, flip, shift, useFloating} from '@floating-ui/vue';
import { Events } from '../events';
 
const emit = defineEmits(['open', 'close'])
let props = defineProps({
  placement: String,
  'class': [Object, Array, String],
  containerClass: String,
  title: String,
  tooltipPlacement: String,
  btnWidth: String
})

let {'class': className, placement, containerClass, close} = props;


const reference = ref(null);
const floating = ref(null);
const {floatingStyles} = useFloating(reference, floating, {
  placement,
  middleware: [flip(), shift()],
  whileElementsMounted: autoUpdate,
  strategy: 'fixed'
});
const visible = ref(false)
watch(visible, (open) => {
  if (open) {
    emit('open')    
  } else {
    emit('close')
  }
});

function nopropagate(e) {
  if (visible.value) { 
    visible.value = false
  } else {
    Events.dispatch(Events.CLEAR_DOPDOWNS)
    visible.value = true
  }
  e.stopPropagation();
  // e.stopImmediatePropagation();
  // e.preventDefault();  
  // return false;
}

function handleClickAway(event) {
  if (
    reference.value?.$el &&
    floating.value &&
    !reference.value.$el.contains?.(event.target) &&
    !floating.value.contains?.(event.target)
  ) {
    visible.value = false;
  }
}

let eventGroup;
onMounted(() => {
  Events.listen(Events.CLEAR_DOPDOWNS, () => {
    visible.value = false;
  })
  eventGroup = Events.group()
  document.addEventListener('mousedown', handleClickAway);
});

onUnmounted(() => {
  eventGroup?.dispose();
  document.removeEventListener('mousedown', handleClickAway);
});

</script>

<template>
  <Button 
    ref="reference"
    :class="className" 
    :title="props.title"
    :placement="props.tooltipPlacement"
    :style="{      
      width: props.btnWidth
    }"
    @action="nopropagate"
  >
    <slot name="button"/>
  </Button>
  <Teleport to="#app">
    <Transition name="fade-scale">

      <div 
        @pointerup="visible=false"
        v-if="visible"
        ref="floating"
        :style="{...floatingStyles, 'z-index': 999}"
        :class="`rounded-box bg-base-200 shadow-md shadow-base-100 p-2 ${containerClass}`">
        <slot name="content"/>
      </div>
    </Transition>
  </Teleport>
</template>
<style scoped lang="less">
  .fade-scale-enter-active,
  .fade-scale-leave-active {
    transition: opacity 150ms ease;
  }

  .fade-scale-enter-from,
  .fade-scale-leave-to {
    opacity: 0;
  }

  .fade-scale-enter-to,
  .fade-scale-leave-from {
    opacity: 1;
  }
</style>